import { Header } from "../../components/folders/Header.tsx";
import { Cards } from "../../components/folders/Cards.tsx";
import { fetchAllUsers } from "../../redux/actions/usersActions.tsx";
import { useAppDispatch, useAppSelector } from "../../redux/hooks.ts";
import { useEffect } from "react";

export default function FoldersPage() {
  const dispatch = useAppDispatch();
  const { userInfo } = useAppSelector((state) => state.auth);
  const isAdmin = userInfo?.groups.includes("admin");

  const onFetchUsers = async () => {
    if (!isAdmin) return;

    await dispatch(fetchAllUsers("/accounts/users/?limit=1000"));
  };

  useEffect(() => {
    onFetchUsers();
  }, [isAdmin]);

  return (
    <div className="w-full h-full p-8">
      <Header />
      <Cards />
    </div>
  );
}
